import React from 'react';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';
import { BUTTON_AS_TYPE, VARIANT } from '@motorway/mw-highway-code/enums';

import { wordpressImgToImgixURL } from 'Utilities';
import { vehicleType } from 'Utilities/helpers';

import { Content } from 'LegacySBCRA/Content/Content';
import { RelatedGuides } from 'Storybook/components/local/RelatedGuides';

import texts from '../../../../../texts.json';
import { usePageRefEvents } from '../../../common/Hooks/usePageRefEvents';
import { RelatedGuidesContentType } from '../../Pages/LandingPage.helpers';

import styles from './RelatedGuidesSectionBespoke.scss';

const LocalT = new MDText(texts);

const t = (key: string, props?: { [key:string]: unknown }) => LocalT.translate(key, props) as string;

type RelatedGuidesProps = {
  guides: RelatedGuidesContentType;
  onLoad: () => void;
  redirectToUrl: string;
  sectionTitle: string;
};

const ImgixWidth = 288;

export const RelatedGuidesSectionBespoke = ({
  guides,
  onLoad,
  redirectToUrl,
  sectionTitle,
}: RelatedGuidesProps) => {
  const { setRef } = usePageRefEvents({ onRefTrigger: onLoad });

  return (
    <div ref={(ref) => setRef(ref)} className={styles.component} data-testid='relatedGuidesBespoke'>
      <Content className={styles.contentWrapper}>
        <h2 className={styles.relatedGuidesTitle}>{sectionTitle || t('landingPageRelatedGuides.title')}</h2>
        <div className={styles.relatedGuidesBody}>
          {
            guides.map(({ description, thumbnail, title, url }) => (
              <RelatedGuides
                key={title}
                {...{ description, title, url }}
                imgAlt={typeof thumbnail === 'string' ? '' : thumbnail?.alt}
                imgSrc={`${wordpressImgToImgixURL(typeof thumbnail === 'string' ? thumbnail : thumbnail?.url)}&w=${ImgixWidth}`}
                wrapperClassName={styles.relatedGuidesCard}
              />
            ))
          }
        </div>

        <Button
          as={BUTTON_AS_TYPE.ANCHOR}
          href="/sell-my-car/guides"
          icon='chevron'
          label={t('landingPageRelatedGuides.link', {
            vehicle: vehicleType(redirectToUrl),
          })}
          variant={VARIANT.SECONDARY}
        />
      </Content>
    </div>
  );
};
